module.exports = "./img/860d276bcfddea0437274da7dec92e8e.jpg";